import styles from './index.module.scss';

const FullPageLoader = () => {
  return (
    <div className={styles.fullPageSkeleton}>
      <div className={styles.left}>
        <div className={styles.skeletonHero}></div>
        <div className={styles.skeletonHeader}></div>
        <div className={styles.skeletonHeader}></div>
      </div>
    </div>
  );
};

export default FullPageLoader;
